// components/AdminPanel.js
import React from 'react';
import { Typography, Button } from '@mui/material';
import { useCompetitions } from './CompetitionContext';
import { Link } from 'react-router-dom';

const AdminPanel = () => {
  const { competitions, loading } = useCompetitions();

  if (loading) return <Typography variant="body1">Ładowanie...</Typography>;

  return (
    <div style={{ padding: '20px' }}>
      <Typography variant="h4">Panel Administracyjny</Typography>
      <Typography variant="body1">Witaj w panelu administracyjnym. Funkcjonalności w trakcie rozwoju.</Typography>
      
      <Button
        variant="contained"
        color="primary"
        component={Link}
        to="/janekjot/addMatch"
        sx={{ mt: 2 }}
      >
        Dodaj nowy mecz
      </Button>
      
      <Button
        variant="contained"
        color="primary"
        component={Link}
        to="/janekjot/manageSimulations"
        sx={{ mt: 2, ml: 2 }}
      >
        Zarządzanie symulacjami
      </Button>

      <Button
        variant="contained"
        color="primary"
        component={Link}
        to="/janekjot/polymarket"
        sx={{ mt: 2, ml: 2 }}
      >
        Polymarket MS
      </Button>

      <Button
        variant="contained"
        color="primary"
        component={Link}
        to="/janekjot/odds"
        sx={{ mt: 2, ml: 2 }}
      >
        Kursy bukmacherow MS
      </Button>
    </div>
  );
};

export default AdminPanel;
